<template>
  <!-- 产品中心 -->
  <div>
    <div v-if="this.$route.path == '/pc/product'">
      <!-- 顶部导航 -->
      <TopNav></TopNav>
      <!-- 产品中心轮播图 -->
      <ProductBanner></ProductBanner>
      <!-- 安全、稳定软硬一体化产品 -->
      <Integrated></Integrated>
      <!-- 售后支持 -->
      <AfterSales></AfterSales>
      <!-- 底部导航 -->
      <BottomNav></BottomNav>
    </div>
    <div v-else>
      <router-view></router-view>
    </div>
  </div>
</template>

<script>
import { reactive } from "vue";

import TopNav from "../../../components/pc/components/TopNav.vue";
import BottomNav from "../../../components/pc/components/BottomNav.vue";
import ProductBanner from "../../../components/pc/Product/ProductBanner.vue";
import Integrated from "../../../components/pc/Product/Integrated.vue";
import AfterSales from "../../../components/pc/Product/AfterSales.vue";

export default {
  setup() {
    return reactive({});
  },
  components: {
    TopNav,
    BottomNav,
    ProductBanner,
    Integrated,
    AfterSales,
  },
};
</script>

<style scoped>
</style>
